import { topicQueries } from "@circle-react/lib/queries/topics";
import type { PaginationHelper } from "@circle-react/types";
import type { Topic } from "@circle-react/types/Topic";
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from "react-query";
import { useQuery } from "react-query";

type TopicPickerQueryOptions = Omit<
  UseQueryOptions<PaginationHelper<Topic>>,
  "queryFn" | "queryKey"
>;

interface UseTopicsProps {
  ids?: number[];
  query?: string;
  queryOptions?: TopicPickerQueryOptions;
  spaceId?: string;
}

export const useTopics = ({
  spaceId,
  ids,
  query,
  queryOptions,
}: UseTopicsProps): UseQueryResult<PaginationHelper<Topic>> => {
  const config = topicQueries.pickerList({ spaceId, ids, query });

  return useQuery<PaginationHelper<Topic>>({
    ...queryOptions,
    queryKey: config.queryKey,
    queryFn: config.queryFn as QueryFunction<PaginationHelper<Topic>, QueryKey>,
  });
};
